import {
  CampaignTaskType,
  CbDeliverableV2Status,
} from 'api/graphql-global-types';

export const DONE_DELIVERABLE_STATUSES = [
  CbDeliverableV2Status.CONTENT_APPROVED,
  CbDeliverableV2Status.ON_BRAND_REVIEW,
  CbDeliverableV2Status.PUBLISHED,
];

export const POST_DELIVERABLE_LINK_TYPES = [
  CampaignTaskType.IG_POST,
  CampaignTaskType.IG_REEL,
  CampaignTaskType.TT_VIDEO,
  CampaignTaskType.TW_TWEET,
  CampaignTaskType.TW_VIDEO,
  CampaignTaskType.TW_LIVE,
];

export const DELIVERABLES_TIMELINE_CARDS_MAX_SLOTS = 2;
